import { render } from "./Status.vue?vue&type=template&id=337d1cd0"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"
script.render = render

export default script